import { Routes, Route, Navigate } from 'react-router-dom';
import CampaignsPage from './index';
import { CampaignCreateLayout } from './create/layout';
import { AudienceStep } from './create/pages/audience';
import { DesignPage } from './create/pages/design';
import { ReviewPage } from './create/pages/review/review';
import { useFeature } from '@/hooks/use-feature';

/**
 * CampaignsRoutes handles all campaign-related routing.
 * This follows the same pattern as tracking, where we have a nested Routes
 * component that handles all sub-routes. This makes relative navigation
 * more predictable as '..' will navigate based on route hierarchy
 * rather than URL segments.
 */
export function CampaignsRoutes() {
  const isCampaignsEnabled = useFeature('CAMPAIGNS');

  if (!isCampaignsEnabled) {
    return <Navigate to="/" replace />;
  }

  return (
    <Routes>
      <Route index element={<CampaignsPage />} />
      <Route path="create" element={<CampaignCreateLayout />}>
        <Route index element={<Navigate to="audience" replace />} />
        <Route path="audience" element={<AudienceStep />} />
        <Route path="design" element={<DesignPage />} />
        <Route path="review" element={<ReviewPage />} />
      </Route>
    </Routes>
  );
}
